module.exports = __webpack_public_path__ + "static/media/UG.a0f71ea6.svg";